export default "__VITE_ASSET__DvgdXEY9__"